import { render, staticRenderFns } from "./_rescueFundSummary.vue?vue&type=template&id=70c5cd35&lang=pug"
import script from "./_rescueFundSummary.vue?vue&type=script&lang=js"
export * from "./_rescueFundSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports